'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TypeParameters = exports.Type = undefined;
exports.joined = joined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactRouterDom = require('react-router-dom');

var _urls = require('../../lib/urls');

var _docs = require('./docs');

var _syntax = require('./syntax');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function joined(delimiter, fn) {
    return function (e, i) {
        return i === 0 ? React.cloneElement(fn(e), { key: i }) : React.createElement("span", { key: i }, delimiter, fn(e));
    };
}
function typeUrl(apiDocs, type) {
    var id = apiDocs.data.typeDeclaration[type.id];
    var modulePath = apiDocs.data.declarationModule[id];
    var module = apiDocs.data.modules[modulePath];
    var declaration = module && module.declarations[id];
    return declaration && (0, _urls.entryUrl)(declaration, module, apiDocs);
}
function typeImportPath(apiDocs, type) {
    var id = apiDocs.data.typeDeclaration[type.id];
    var modulePath = apiDocs.data.declarationModule[id];
    var module = apiDocs.data.modules[modulePath];
    return module && (0, _docs.importPath)(module, apiDocs);
}
var Type = exports.Type = function Type(_ref) {
    var type = _ref.type,
        apiDocs = _ref.apiDocs;

    switch (type.kind) {
        case 'Named':
            return React.createElement("span", null, typeUrl(apiDocs, type) ? React.createElement(_reactRouterDom.Link, { to: typeUrl(apiDocs, type), title: 'from ' + typeImportPath(apiDocs, type) }, React.createElement(_syntax.TypeName, null, type.name)) : React.createElement(_syntax.TypeName, { title: type.importedFrom && 'from ' + type.importedFrom, style: { cursor: 'default' } }, type.name), type.parameters && React.createElement(TypeParameters, { parameters: type.parameters, apiDocs: apiDocs }));
        case 'Object':
            return React.createElement("span", null, '{', type.properties.map(joined(', ', function (p) {
                return React.createElement("span", null, p.name, ": ", React.createElement(Type, { type: p.type, apiDocs: apiDocs }));
            })), type.index && React.createElement("span", null, type.properties.length > 0 && ', ', '[', type.index.name, ": ", React.createElement(_syntax.TypeName, null, "string"), ']: ', React.createElement(Type, { type: type.index.type, apiDocs: apiDocs })), '}');
        case 'Tuple':
            return React.createElement("span", null, '[', type.properties.map(joined(', ', function (p) {
                return React.createElement(Type, { type: p, apiDocs: apiDocs });
            })), ']');
        case 'Function':
            return React.createElement("span", null, type.typeParameters && React.createElement(TypeParameters, { parameters: type.typeParameters, apiDocs: apiDocs }), "(", type.parameters.map(joined(', ', function (p) {
                return React.createElement("span", null, p.name, ": ", React.createElement(Type, { type: p.type, apiDocs: apiDocs }));
            })), ") => ", React.createElement(Type, { type: type.returnType, apiDocs: apiDocs }));
        case 'Union':
            return React.createElement("span", null, type.types.map(joined(' | ', function (t) {
                return React.createElement(Type, { type: t, apiDocs: apiDocs });
            })));
        case 'Intersection':
            return React.createElement("span", null, type.types.map(joined(' & ', function (t) {
                return React.createElement(Type, { type: t, apiDocs: apiDocs });
            })));
        case 'BooleanLiteral':
            return React.createElement(_syntax.Keyword, null, type.value);
        case 'NumberLiteral':
            return React.createElement(_syntax.NumberLiteral, null, type.value);
        case 'StringLiteral':
            return React.createElement(_syntax.StringLiteral, null, '\'', type.value, '\'');
    }
};
var TypeParameters = exports.TypeParameters = function TypeParameters(_ref2) {
    var parameters = _ref2.parameters,
        apiDocs = _ref2.apiDocs;
    return React.createElement("span", null, '<', parameters.map(joined(', ', function (p) {
        return React.createElement(Type, { type: p, apiDocs: apiDocs });
    })), '>');
};
//# sourceMappingURL=types.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/documittu-template-default/dist/components/ui/types.js
 ** module id = 85
 ** module chunks = 0
 **/